export default __webpack_public_path__ + "f2d0f59a21f4ca2bb9a2dcdcb6727450.png";